<template>
  <span class="UITitleHighlight">
    <slot />
  </span>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.UITitleHighlight {
  // Base gradient text treatment
  background: linear-gradient(45deg, #023025 0%, #04785e 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
</style>
